<div class="d-flex justify-content-center align-items-center w-100 h-100 login-container">
  <div class="col-xl-4 col-md-6 col-10">
    <div class="card border-0 box-shadow rounded-0">
        <div class="card-header d-flex justify-content-center logo-bg align-items-center border-0 box-shadow">
          <img class="logo" src="assets/img/app/aladdin-icon-blue.png">
        </div>
        <div class="card-body text-center pb-2">
            <h2>Employee Login</h2>
            <form [formGroup]="form" (ngSubmit)="login()" class="text-left mt-4" data-testid="internal-login-form">
                <div class="form-group">
                  <button [disabled]="isLoading" class="btn btn-block silver-lake-blue" type="submit" data-testid="internal-login-sign-in">
                    <span *ngIf="!isLoading">Sign in</span>
                    <span *ngIf="isLoading">Please wait...</span>
                  </button>
                </div>                    
            </form>
            <div class="error-message" role="alert" *ngIf="errorMessage">
              <div class="d-flex flex-nowrap">
                <span class="fa fa-exclamation-triangle align-self-center mx-2"></span>
                <span class="mx-1">{{errorMessage}}</span>
                <span class="fa fa-exclamation-triangle align-self-center mx-2"></span>
              </div>
            </div>
            <div class="text-right">
                <a class="external-user-link" routerLink="/auth/login" (click)="onSwitchToExternalLogin()" data-testid="internal-login-switch-to-external-user">Switch to external user login</a>
            </div>
        </div>            
    </div>
    <app-login-show-app-version>
    </app-login-show-app-version>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/auth/internal-login/internal-login.component.html